"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Alignment = exports.Justification = exports.BASE_SPACING = exports.BASE_STYLES = void 0;

var _spacing = require("../themes/default/spacing");

var _styledComponents = require("styled-components");

var _templateObject;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var BASE_STYLES = (0, _styledComponents.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  max-width: 100%;\n"])));
exports.BASE_STYLES = BASE_STYLES;

var spacingValues = _objectSpread(_objectSpread({}, _spacing.Tokens), _spacing.Semantics);

var BASE_SPACING = spacingValues.Small;
exports.BASE_SPACING = BASE_SPACING;
var Justification = {
  Center: 'center',
  FlexStart: 'flex-start',
  FlexEnd: 'flex-end',
  SpaceBetween: 'space-between',
  SpaceAround: 'space-around'
};
exports.Justification = Justification;
var Alignment = {
  Center: 'center',
  FlexStart: 'flex-start',
  FlexEnd: 'flex-end',
  Baseline: 'baseline',
  Stretch: 'stretch'
};
exports.Alignment = Alignment;
var _default = spacingValues;
exports["default"] = _default;